module.exports = __webpack_public_path__ + "static/img/product16.c796197.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product16.png
// module id = gvuS
// module chunks = 1